import React, { useEffect, useState } from "react";
import AddComponent from "../Base/AddComponent";
import { getLoggedUser } from "../../context/auth";

let loggedUser = {};
const GlobalConfig = new window.globalConfig();

class App extends AddComponent {
  constructor(props) {
    super();
    loggedUser = getLoggedUser();
    const parentState = { ...this.state };
    this.state = {
      title: "System Setting",
      listtitle: "System Settings",
      urllist: process.env.REACT_APP_URL_SYSTEMCONFIG_LIST,
      urlapi: GlobalConfig.REACT_APP_API_SYSTEMCONFIG_URL,
      alertshow: false,
      alerttype: "",
      alertmsg: "",
      data: {
        _id: "",
        name: "",
        value: "",
        createdUserId: loggedUser._id,
        createdDate: new Date(),
        modifiedUserId: "",
        modifiedDate: null,
      },
      loading: parentState.loading,
    };
  }

  handResetForm = () => {
    this.setState({
      data: {
        _id: "",
        name: "",
        value: "",
        createdUserId: loggedUser._id,
        createdDate: new Date(),
        modifiedUserId: "",
        modifiedDate: null,
      },
    });
  };

  renderForm = () => {
    return (
      <div className="panel-body">
        <div className="form-group">
          <label className="col-sm-3 control-label">
            Name <span className="required">*</span>
          </label>
          <div className="col-sm-9">
            <input
              type="text"
              name="name"
              autoFocus={true}
              className="form-control"
              placeholder=""
              required
              value={this.state.data.name}
              onChange={this.handleChange}
              maxLength={100}
            />
          </div>
        </div>
        <div className="form-group">
          <label className="col-sm-3 control-label">
            Value <span className="required">*</span>
          </label>
          <div className="col-sm-9">
            <textarea
              name="value"
              className="form-control"
              placeholder=""
              required
              value={this.state.data.value}
              onChange={this.handleChange}
              rows={10}
              maxLength={4000}
              data-plugin-markdown-editor
            />
          </div>
        </div>
      </div>
    );
  };
}
export default App;
